var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commponent--playing-symbol"},[_c('i',{staticClass:"stick",style:({ background:_vm.color })}),_c('i',{staticClass:"stick",style:({ background:_vm.color })}),_c('i',{staticClass:"stick",style:({ background:_vm.color })}),_c('i',{staticClass:"stick",style:({ background:_vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }